import { render, staticRenderFns } from "./widget2.vue?vue&type=template&id=587607cc&scoped=true"
import script from "./widget2.vue?vue&type=script&lang=js"
export * from "./widget2.vue?vue&type=script&lang=js"
import style0 from "./widget2.vue?vue&type=style&index=0&id=587607cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587607cc",
  null
  
)

export default component.exports